module.exports = __webpack_public_path__ + "img/question.d606fdd0.svg";